import api from '../token';

export const AddCambio = async (dados) => {
  try {
    const response = await api.post('/addCambio', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};


